var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalBookingAnalyticIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.247681,
    y: 0.3479,
    width: 45.8696,
    height: 45.8696,
    rx: 5,
    fill: "#438CBE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6437 19.3495C23.2888 19.744 22.7283 19.744 22.3733 19.3495L21.7381 18.6435C20.9947 17.8171 19.9903 17.3126 18.8803 17.3126C16.6003 17.3126 14.752 19.4532 14.752 22.0939C14.752 24.6255 15.9353 26.716 17.6434 28.4335C19.353 30.1526 21.3971 31.2927 22.6183 31.8745C22.8737 31.9962 23.1434 31.9962 23.3988 31.8745C24.62 31.2927 26.6641 30.1526 28.3737 28.4335C30.0818 26.716 31.2651 24.6255 31.2651 22.0939C31.2651 19.4532 29.4168 17.3126 27.1368 17.3126C26.0268 17.3126 25.0224 17.8171 24.2789 18.6435L23.6437 19.3495ZM23.0085 17.1102C21.9371 15.9194 20.4825 15.1875 18.8803 15.1875C15.587 15.1875 12.9172 18.2796 12.9172 22.0939C12.9172 28.8604 19.3118 32.597 21.9203 33.8398C22.6228 34.1745 23.3942 34.1745 24.0968 33.8398C26.7053 32.597 33.0998 28.8603 33.0998 22.0939C33.0998 18.2796 30.4301 15.1875 27.1368 15.1875C25.5346 15.1875 24.08 15.9194 23.0085 17.1102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBookingAnalyticIcon);
export default __webpack_public_path__ + "static/media/TotalBookingAnalytic-Icon.c2c3b687802302a7cf96f6c68446bce0.svg";
export { ForwardRef as ReactComponent };